<template>
  <div class="form-item" v-show="visible">
    <div class="form-item ve-upload">
      <div @click="uploadFile">
        <div style="font-size:14px;font-weight:bold;margin-bottom:5px" v-if="!isListItem">{{localized(`label`)}}</div>
        <el-upload
          action
          :class="{ hiddenUpload:  fileList.length }"
          :file-list="fileList"
          class="audio-file"
          :on-remove="handleRemoveFile"
          :before-upload="beforeUpload"
          :disabled="disabled"
        >
          <img src="@/assets/audio_active.png" class="ve-upload-icon" v-if="fileList.length" />
          <img src="@/assets/audio.png" class="ve-upload-icon" v-else />
          <div class="el-upload__text">
            <em>{{$t('app.upload_audio')}}</em>
          </div>
        </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
import callApp from "@/services/sdk";
import language from '@/lang'
export default {
  uuid: "00000000-0000-0000-0000-000000100003",
  components: {},
  props: ["jsonContent", "fatherContent", "datamodel", "disabled", "host", "contextData", "editStatus", "father"],
  data() {
    return {
      itemdata: "",
      fileList: [],
      fileName: "",
      formLabelAlign: {
        // filelocation: "",
        // filesize: "0",
        // filetype: "",
        // filename: "",
        // filehash: ""
      }
    };
  },
  computed: {
    content() {
      return Object.keys(this.jsonContent).length
        ? this.jsonContent
        : this.fatherContent;
    },
    visible() {
      if (this.fatherContent.itemType) {
        return this.fatherContent.itemType.displayReference.visible;
      }
      return this.fatherContent.displayReference.visible;
    },
    hostKey(){
      return this.host + "." + this.fatherContent.key
    },
    isListItem() {
      return this.father && this.father.itemType && Object.keys(this.father.itemType).length > 0
    }
  },
  methods: {
    beforeUpload() {
      return false;
    },
    localized(key) {
      return language.localize(
        this.$store.state,
        this.fatherContent.key,
        key,
        this.fatherContent.displayReference[key]
      )
    },
    uploadFile(e) {
      if (e.target.className !== "el-upload__input") return;
      callApp(
        "getFile",
        {
          type: "dataSource.file.file",
          data: {
            max: this.content.controlReference.max,
            type: this.content.controlReference.acceptedFileType || []
          }
        },
        "cbGetFile"
      ).then(data => {
        this.fileList = [];
        this.itemdata = {
          filehash: "",
          filelocation: "",
          filename: "",
          filesize: "",
          filetype: ""
        };
        this.formLabelAlign = {}
        // this.formLabelAlign = {
        //   filehash: "",
        //   filelocation: "",
        //   filename: "",
        //   filesize: "",
        //   filetype: ""
        // };
        this.$nextTick(() => {
          if (data.files) {
            this.itemdata = { ...data.files[0] };
            this.formLabelAlign = { ...data.files[0] };
            this.fileName = data.files[0].filename;
            this.fileList = [
              {
                url: this.spliceUrl(data.files[0].filelocation),
                name: this.fileName
              }
            ];
          }
        });
      });
      e.preventDefault();
    },
    handleRemoveFile() {
      this.fileName = "";
      this.fileList = [];
    },
    spliceUrl(location) {
      const domain = this.$store.state.domain;
      const token = this.$store.state.token;
      return location ? domain + location + "?token=" + token : location;
    }
  },
  created() {},
  mounted() {
    this.fileName = this.datamodel && this.datamodel.filename;
    this.fileName &&
      (this.fileList = [
        {
          url: this.spliceUrl(this.datamodel.filelocation),
          name: this.fileName
        }
      ]);
    if (this.datamodel != undefined) {
      this.$nextTick(() => {
        this.formLabelAlign = this.datamodel;
      });
    }
  },
  watch: {
    formLabelAlign: {
      handler(val) {
        this.$emit("fatherCall", {
          key: this.fatherContent.key,
          value: val.filelocation !== "" ? val : {}
        });
      },
      deep: true
    }
  }
};
</script>
<style lang='scss' scoped>
.ve-upload-icon {
  width: 62px;
  position: relative;
  margin-top: 40px;
}
.el-upload__text em {
  color: #9b9b9b !important;
  font-weight: 500;
}
.el-upload-list--picture-card {
  display: flex;
  justify-content: center;
  .el-upload-list__item {
    width: 100%;
    height: auto;
    margin-right: 0;
  }
}
.el-upload--picture-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  img {
    align-self: center;
  }
}
.el-upload__text {
  font-size: 14px;
  line-height: 48px;
}
</style>